<h1 fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" mat-dialog-title>
	<div>Scan {{ data?.barcodeTranslationConfig?.description }}</div>
	<button color="primary" mat-dialog-close mat-icon-button>
		<mat-icon>close</mat-icon>
	</button>
</h1>
<p>
	Scan barcode using a bluetooth or USB scanner, or enter the barcode manually using the input field below. Select how you would like your orders placed below.
</p>
<mat-form-field fxLayout="column" fxLayoutAlign="end" class="padding-top-1em">
	<mat-label>Barcode</mat-label>
	<input matInput type="text" [(ngModel)]="barcode">
	<button *ngIf="barcode" matSuffix mat-icon-button aria-label="Clear" (click)="clearBarcode()">
		<mat-icon>close</mat-icon>
	</button>
</mat-form-field>
<mat-radio-group
		fxLayout="row wrap"
		fxLayoutGap="15px grid"
		name="radios"
		[(ngModel)]="placementOption"
		class="padding-top-05em">
	<mat-radio-button color="primary" value="manual" matTooltip="Scan will populate data into the fields of the order and closes the scan modal to allow users to review their information before manually placing the order.">
		{{ "Manual Placement" | translate }}
	</mat-radio-button>
	<mat-radio-button color="primary" value="auto" matTooltip="Each scan will automatically generate an entire order and place it without review, so continuous scanning can occur. Displays success message as each order is processed and placed.">
		{{ "Auto Placement" | translate }}
	</mat-radio-button>
	<mat-radio-button *ngIf="user?.allowCartCheckout" color="primary" value="cart" matTooltip="Each scan will automatically generate an entire order and place it into the cart, so continuous scanning can occur. Users can click on orders within the cart to review their data before placing them.">
		{{ "Add to Cart" | translate }}
	</mat-radio-button>
</mat-radio-group>
<mat-dialog-actions fxLayoutAlign="end">
	<button color="primary" mat-raised-button (click)="apply()">
		<span>{{ "Apply" | translate }}</span>
	</button>
</mat-dialog-actions>